import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { UserGroupIndexSelectComponent } from '../user-groups/crud-index/crud-index-select.component';
import { AuthService } from 'src/app/views/auth/shared/auth.service';

export const RELATIVE_URL = 'users';
export const COLUMNS_TO_SHOW_WEB = [
  'name',
  'document',
  'groups',
  'username',
  'createdAt',
  'actions',
];
export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;

export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    field_type: FieldTypeEnum.LABEL,
    display: 'Nome Completo',
    property: 'name',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    display: 'CPF/CNPJ',
    property: 'document',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    display: 'Grupos',
    property: 'groups',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    display: 'Usuário',
    property: 'username',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    display: 'Criado em',
    property: 'createdAt',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
];

export const CES_CONFIG_FIELDS: IFieldConfig[] = [
  {
    name: 'id',
    type: TypeComponentFieldEnum.HIDDEN,
  },
  {
    name: 'image',
    type: TypeComponentFieldEnum.IMAGE,
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'Grupo',
    name: 'userGroups',
    value: 'name',
    display: 'description',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'Filiais/Unidades permitidas',
    name: 'branches',
    display: 'name',
    options: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'Nome',
    name: 'firstName',
    placeholder: 'Informe o nome do usuário',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'Sobrenome',
    name: 'lastName',
    placeholder: 'Insira sobrenome do usuário',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'Telefone / Celular',
    name: 'phone',
    placeholder: 'Informe o numero de telefone',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'E-mail',
    name: 'email',
    placeholder: 'Informe o nome do cliente',
    validation: [Validators.required, Validators.email],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'Usuário',
    name: 'username',
    placeholder: 'Informe o nome do cliente',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'CPF',
    name: 'document',
    placeholder: 'CPF do usuário',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    inputType: 'password',
    label: 'Senha',
    name: 'password',
    placeholder: 'Informa nova senha do usuário',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'Nova Senha',
    inputType: 'password',
    name: 'newPassword',
    placeholder: 'Repita a senha',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'Confirmar Senha',
    inputType: 'password',
    name: 'confirmPassword',
    placeholder: 'Repita a senha',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'Obrigatório alterar a senha no primeiro acesso',
    name: 'requireChangePassword',
    validation: [],
  },
];
